export default "__VITE_ASSET__PqfV23LX__"